import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Iter 860 — chaîne YouTube @RHONEAMITIEVOYAGES : dernières vidéos (accueil) ou vidéos d'un voyage (page voyage). Lecture sur place, sans cookie.
export const VideosYoutube = ({ tripId = null, limit = 3, titre = 'Nos vidéos', compact = false }) => {
  const [d, setD] = useState(null);
  const [lecture, setLecture] = useState(null);
  useEffect(() => {
    axios.get(`${API}/youtube/videos`, { params: { trip_id: tripId || undefined, limit } }).then(r => setD(r.data)).catch(() => setD({ videos: [] }));
  }, [tripId, limit]);
  if (!d || !d.videos.length) return null;
  return (
    <section className={compact ? 'py-6' : 'section bg-white'} data-testid="videos-youtube">
      <div className={compact ? '' : 'container-custom'}>
        <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
          <h2 className={`${compact ? 'text-xl' : 'text-3xl md:text-4xl'} font-bold text-[#1E3A5F] flex items-center gap-2`} data-testid="videos-youtube-titre">
            <svg className="w-8 h-8 text-[#FF0000]" viewBox="0 0 24 24" fill="currentColor"><path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1A31 31 0 0 0 24 12a31 31 0 0 0-.5-5.8zM9.6 15.6V8.4l6.2 3.6-6.2 3.6z" /></svg>
            {titre}
          </h2>
          <a href={d.chaine} target="_blank" rel="noopener noreferrer" className="inline-flex items-center min-h-[44px] text-sm font-semibold text-[#1E3A5F] underline" data-testid="videos-youtube-chaine">Voir la chaîne YouTube →</a>
        </div>
        <div className={`grid gap-4 ${compact ? 'grid-cols-1 sm:grid-cols-2' : 'grid-cols-1 md:grid-cols-3'}`}>
          {d.videos.map(v => (
            <div key={v.id} className="rounded-2xl overflow-hidden shadow-md bg-black" data-testid={`video-${v.id}`}>
              {lecture === v.id ? (
                <iframe title={v.titre} src={`${v.embed}?autoplay=1&rel=0`} className="w-full aspect-video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-testid={`video-player-${v.id}`} />
              ) : (
                <button type="button" onClick={() => setLecture(v.id)} className="relative block w-full aspect-video group" aria-label={`Lire : ${v.titre}`} data-testid={`video-play-${v.id}`}>
                  <img src={v.miniature} alt={v.titre} className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition" loading="lazy" />
                  <span className="absolute inset-0 flex items-center justify-center"><span className="w-16 h-11 rounded-xl bg-[#FF0000] flex items-center justify-center shadow-lg group-hover:scale-110 transition"><svg className="w-6 h-6 text-white ml-0.5" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z" /></svg></span></span>
                </button>
              )}
              <div className="bg-white p-3">
                <p className="font-semibold text-sm text-[#1E3A5F] line-clamp-2" data-testid={`video-titre-${v.id}`}>{v.titre}</p>
                {v.publie_le && <p className="text-xs text-gray-500 mt-0.5">{new Date(v.publie_le).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideosYoutube;
